import moment, { Moment } from 'moment'

import { IWorkingHours } from '../../../App/store/features/person/interface/IWorkingHours'

export const calcWorkingTimeSlots = (
  workingHours: IWorkingHours[],
  personId: number,
  schemaWeek: number,
  timeDivision: number,
  date: Moment,
): number[] =>
  workingHours
    .filter(
      (workingHour: IWorkingHours) =>
        workingHour.attributes.userId === personId &&
        workingHour.attributes.schemaWeek === schemaWeek &&
        workingHour.attributes.weekDay === date.isoWeekday(),
    )
    .map(workingHour => {
      let minutesSinceMidnight = workingHour.attributes.startsAt.diff(
        moment().startOf('day'),
        'minutes',
      )
      minutesSinceMidnight =
        Math.round(minutesSinceMidnight / timeDivision) * timeDivision

      const workingSlotKeys = []
      for (let i = 0; i < workingHour.attributes.duration; i += timeDivision) {
        workingSlotKeys.push(minutesSinceMidnight + i)
      }

      return workingSlotKeys
    })
    .flat()
